import { Fields } from "../../../FieldNames";
import { getFieldLabelId } from "../../../../helpers/contentTypeLabelId";
import { META_URL_FIELD } from "../../../../types/ContentType";
import { FieldType } from "../../../../types/ContentType/fields";
export var metaUrlField = {
  type: FieldType.MetaUrl,
  name: Fields.URL,
  labelId: getFieldLabelId(Fields.URL),
  metaDataField: META_URL_FIELD
};